<div class="u-padding-40">

	<app-custom-back-button *ngIf="hasChildRoutes"></app-custom-back-button>

	<p class="u-text-uppercase u-font-size-10 u-color-red-faded u-font-weight-700">Get Started with INSCYD</p>
	<p class="general-info--font-size-35 u-font-weight-400 u-margin-bottom-20">Welcome to INSCYD <span>{{
			auth.first_name }} {{ auth.last_name }}</span></p>
	<!-- <app-progress-bar [value$]="onboardingProgress" label="Onboarding Progress"></app-progress-bar> -->
	<div class="u-margin-top-20">
		<router-outlet></router-outlet>
	</div>
</div>